import { render, staticRenderFns } from "./CompetencyMarkCard.vue?vue&type=template&id=29dbde58&scoped=true"
import script from "./CompetencyMarkCard.vue?vue&type=script&lang=js"
export * from "./CompetencyMarkCard.vue?vue&type=script&lang=js"
import style0 from "./CompetencyMarkCard.vue?vue&type=style&index=0&id=29dbde58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dbde58",
  null
  
)

export default component.exports